/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Final_TitleInputs */

const en_cp_final_title = /** @type {(inputs: Cp_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with one pilot class this semester`)
};

const id_cp_final_title = /** @type {(inputs: Cp_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari satu kelas pilot semester ini`)
};

/**
* | output |
* | --- |
* | "Start with one pilot class this semester" |
*
* @param {Cp_Final_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_final_title = /** @type {((inputs?: Cp_Final_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Final_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_final_title(inputs)
	return en_cp_final_title(inputs)
});